export default __webpack_public_path__ + "static/media/guardianas8.1ab37085.png";